
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Link, Image } from '@ta-interaktiv/contentbricks'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>Sars-CoV-2 wurde <Link href='https://jamanetwork.com/journals/jamanetworkopen/fullarticle/2767009' allowWordWrap mdxType="Link">in Fäkalien gefunden</Link>, scheint aber dort nicht infektiös zu sein. Das Virus wurde ebenfalls auf <Link href='https://www.medrxiv.org/content/10.1101/2020.04.03.20052175v1' allowWordWrap mdxType="Link">Toilettenoberflächen in Patientenzimmern</Link> nachgewiesen, es ist aber nicht klar, ob es durch direkten Kontakt oder durch Aerosole dorthin gelangt ist. Das Spülen mit Wasser kann Aerosole freisetzen. Das <Link href='https://pubs.acs.org/doi/abs/10.1021/acs.est.6b04846' mdxType="Link">Gesamtvolumen</Link> ist jedoch gering, vergleichbar mit der Menge, die ausgestossen wird, wenn eine Person «Hello, World!» sagt. In einer <Link href='https://www.sciencedirect.com/science/article/pii/S0196655314002491' mdxType="Link">Studie</Link>{' '}wurden in der Luft von Toiletten in Krankenhaus- und Bürogebäuden weitere Atemwegsviren gefunden, die aber eher auf das Ausatmen der Menschen als auf die Toilettenspülung zurückzuführen waren. Eine <Link href='https://pubs.acs.org/doi/abs/10.1021/acs.est.6b04846' mdxType="Link">Laborstudie</Link> zu Viren, die sich in Toilettenschüsseln ansammeln, konnte diese nach der Spülung nicht in der Luft nachweisen. Dennoch sollte man vor der Spülung den Toilettendeckel schliessen.</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;